import React from 'react';
import Card from 'react-bootstrap/Card';
import styles from './MemberRegistration.css';
export default function MemberRegistration(){
return (
<div className="container">
<Card className="card-background"> <Card.Body>
<blockquote className="blockquote mb-0">
<h1 className="text-header">South Dakota IOX Member Registration</h1>
<ul className="registration-list">
<li>South Dakota Interoperability Exchange (IOX) lets you securely access your South Dakota Medicaid information through a Third-Party Personal Health Application (TPPHA).</li>
<li>Download a TPPHA from an app store.</li>
<li>The app must already be registered and approved by South Dakota IOX. </li>
<li>To use a TPPHA, you must have:
    <ul>
        <li>An active South Dakota MySD account</li>
        <li>A completed South Dakota IOX registration</li>
    </ul>
</li>
</ul>

<p><b>Ways to start the IOX registration</b></p>
<ul className="registration-list">
<li>Option 1: Open a web browser, this is the link to the South Dakota IOX Home Page. Link: <a href={`${process.env.REACT_APP_EDUCATIONAL_MATERIAL_URL}home`} >{process.env.REACT_APP_EDUCATIONAL_MATERIAL_URL}home</a>. Under the ‘New Member?’ Section, click the ‘Register Here’ link and follow directions in Step 1 below. You can choose TPPHAs later. </li><br/>
<img src="SD_Home.JPG" alt="South Dakota IOX Home Page" className="sd-image"/><br/>
<li>Option 2: Install a TPPHA that is already registered with IOX. When you select South Dakota Medicaid, the TPPHA will redirect you to IOX for authentication.</li>
</ul>

</blockquote>
</Card.Body>
</Card>
<br/>
<hr className="horizontal-rule"></hr>
<br/>
<Card className="card-background"><Card.Body>

<b>STEP 1: Sign in to MySD</b><br/><br/>
<ul className="registration-list">
<li>On the IOX Registration page, accept the Security Banner. </li>
<li>On the IOX Sign-in page, select MySD. </li>
<li>Sign into your existing MySD account or create a new account.</li>
</ul> 
<br/><br/>
<img src="login.JPG" alt="Sign in or Registration Screen" className="sd-image"/><br/>
<hr className="horizontal-rule"></hr>
<br/><br/>

<p><b>STEP 2: Provide information to validate your identity</b></p>
<ul className="registration-list">
<li>After signing in with MySD, you return to IOX. </li>
<li>If you have not registered with IOX before, you must enter information to verify your identity. </li>
<li>Some fields come from MySD and cannot be changed. Others must be entered by you.</li>
</ul>
Information required:
<ul className="registration-list">
<li>First Name (from MySD, cannot change) </li>
<li>Last Name (from MySD, cannot change) </li>
<li>Date of Birth </li>
<li>Phone Number </li>
<li>Email Address (from MySD, cannot change; used for verification code) </li>
<li>Member ID (your Medicaid member ID) </li>
<li>Social Security Number </li>
<li>Address (from MySD, can be changed) </li>
<li>City (from MySD, can be changed) </li>
<li>State (from MySD, can be changed) </li>
<li>Postal Code (from MySD, can be changed)</li>
</ul>
Next steps after submitting:
<ul className="registration-list">
<li>IOX checks the information to confirm you are authorized. </li>
<li>If you are not authorized, you will see an informational message. </li>
<li>If you are authorized, you continue to the next step.</li>
</ul>
<hr className="horizontal-rule"></hr>
<br/>

<b>STEP 3: Confirm a recent medical visit</b><br/><br/>
<ul className="registration-list">
<li>IOX will show you several medical visits that may belong to you. </li>
<li>Select the correct recent visit. </li>
<li>You only get one attempt. </li>
<li>If the response is incorrect, please wait 24 hours to try again.</li>
</ul>
<hr className="horizontal-rule"></hr>
<br/>

<b>STEP 4: Verify your email</b><br/><br/>
<ul className="registration-list">
<li>IOX sends a verification code to your email. </li>
<li>Enter the code and click VERIFY. </li>
<li>You can request a new code if needed. </li>
<li>Once verified, a Congratulations message appears. </li>
<li>If you started from the IOX landing page, your registration is complete. </li>
<li>If you come from a TPPHA, you will move to the consent step to access your data.</li>
</ul>
<hr className="horizontal-rule"></hr><br/>
<b>STEP 5: Consent for TPPHA access (only if starting from a TPPHA)</b><br/><br/>
<ul className="registration-list">
<li>You will see a page asking you to consent to allow the TPPHA to access your Medicaid data. </li>
<li>Please read the information carefully; it explains how to protect your data. </li>
<li>After you accept, you will return to the TPPHA and can then view your South Dakota Medicaid information.</li>
</ul>
 For additional information on the IOX application and on protecting your data, you can click on other help links within IOX. 



</Card.Body></Card>

</div>
);
}